import { render, staticRenderFns } from "./fileType.vue?vue&type=template&id=58112598&scoped=true&"
import script from "./fileType.vue?vue&type=script&lang=js&"
export * from "./fileType.vue?vue&type=script&lang=js&"
import style0 from "./fileType.vue?vue&type=style&index=0&id=58112598&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58112598",
  null
  
)

export default component.exports